import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/sedna_time_out.svg")